import React from "react";

const PageLoader: React.FC = () => {
  return (
    <div style={styles.overlay}>
      <img
        src="/images/newLoading.gif"
        alt="Loading..."
        style={styles.image}
      />
      {/* <p style={styles.text}>Loading...</p> */}
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  image: {
    width: "150px",
    height: "auto",
  },
  text: {
    marginTop: "1rem",
    fontSize: "1rem",
    color: "#fff",
  },
};

export default PageLoader;
